var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_639_07697"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_639_07697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,26.666748046875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00005,14.5644840234375C10.9556,14.5644840234375,13.6472,17.4355940234375,14.6752,18.6667040234375C13.6472,19.8978140234375,10.9556,22.768934023437502,8.00005,22.768934023437502C5.04449,22.768934023437502,2.35294,19.8978140234375,1.32494,18.6667040234375C2.35294,17.4355940234375,5.04449,14.5644840234375,8.00005,14.5644840234375ZM8.00005,13.3333740234375C4.33249,13.3333740234375,1.22494,16.8329340234375,0.176935,18.1622640234375C-0.0589784,18.4571840234375,-0.0589784,18.8762240234375,0.176935,19.171154023437502C1.22494,20.5004840234375,4.33249,24.0000740234375,8.00005,24.0000740234375C11.6676,24.0000740234375,14.7752,20.5004840234375,15.8232,19.171154023437502C16.0591,18.8762240234375,16.0591,18.4571840234375,15.8232,18.1622640234375C14.7752,16.8329340234375,11.6676,13.3333740234375,8.00005,13.3333740234375ZM8.00005,17.4355940234375C8.66271,17.4355940234375,9.20005,17.9867040234375,9.20005,18.6667040234375C9.20005,19.3467040234375,8.66271,19.8978240234375,8.00005,19.8978240234375C7.33738,19.8978240234375,6.80005,19.3467040234375,6.80005,18.6667040234375C6.80005,17.9867040234375,7.33738,17.4355940234375,8.00005,17.4355940234375ZM8.00005,16.2053740234375C7.02938,16.2053740234375,6.15427,16.8049340234375,5.78316,17.7249340234375C5.4116,18.6449340234375,5.61694,19.7031540234375,6.30316,20.4071540234375C6.98034,21.1092540234375,8.02022,21.3213340234375,8.91827,20.9404840234375C9.81516,20.5600440234375,10.4,19.6622640234375,10.4,18.6667040234375C10.4,17.3071540234375,9.32582,16.2053740234375,8.00049,16.2053740234375L8.00005,16.2053740234375Z",
    fill: "#E6E6E6",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentHistory);
export default __webpack_public_path__ + "static/media/content_history.422aa384d4f65ed87331e06878838edd.svg";
export { ForwardRef as ReactComponent };